import { Check } from "lucide-react";
import { LABEL, VERSIONS } from "@/lib/enhanceApi";

/** What was done to the version you are hearing — plain words, nothing hidden. */
export default function ChangesList({ item, version }) {
  const meta = item.versions?.[version];
  const color = VERSIONS.find((v) => v.key === version)?.color;
  if (!meta) return null;
  return (
    <section data-testid="changes-list" className="rounded-3xl border border-white/[0.08] bg-[#0a0d1c]/80 p-5 sm:p-6">
      <h2 className="font-display text-base font-semibold md:text-lg">What changed in <span style={{ color }}>{LABEL[version]}</span></h2>
      <ul className="mt-3 space-y-2">
        {meta.changes.map((c) => (
          <li key={c} className="flex items-start gap-2 text-[13px] text-white/75">
            <Check className="mt-0.5 h-3.5 w-3.5 flex-shrink-0" style={{ color }} /> {c}
          </li>
        ))}
      </ul>
      <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.16em] text-white/35">
        48 kHz · 24-bit · {meta.channels === 2 ? "stereo" : "mono"} · {meta.lufs} LUFS · starts at 0:00, lines up with the original
      </p>
    </section>
  );
}
